import { init } from 'commandbar';
import { useEffect, useState } from 'react';

import { useCurrentUser } from '~/hooks/account';
import history from '~/lib/history';

import { useUniversalSearch } from './UniversalSearch';

init('1ee489c0');

const CommandBar = () => {
  const [booted, setBooted] = useState(false);
  const { data: user } = useCurrentUser();
  const routerFunc = (path: string) => {
    history.push(path);
  };

  useEffect(() => {
    if (!user || booted) return;
    if (!window.CommandBar) return;

    window.CommandBar.boot(user.id);
    window.CommandBar.addRouter(routerFunc);
    setBooted(true);
  }, [user]);

  // hooks for each command
  useUniversalSearch({ booted });

  return <></>;
};

export { CommandBar };
